// ... existing code ...
document.addEventListener("DOMContentLoaded", function() {
    async function updateShippingMessage() {
      try {
        const response = await fetch("https://api.ipdata.co?api-key=707d6b4c1028c1a7659278a928ac17764a3e7c232b2745974ea253e5");
        const data = await response.json();
        const userState = data.region || "your location";
        
        const shippingMessage = document.getElementById("express-shipping-message");
        const shippingMessageTemp = document.getElementById("express-shipping-temp-tariffs");
        const shippingMessage_pp = document.getElementById("express-shipping-message_pp");
        
        if (shippingMessage) {
          if (data.country_name === "United States" && data.region !== "Alaska"){
            shippingMessage.style.display = "block";
          
            shippingMessage.innerHTML = `<a href="https://organicformulastore.com/pages/shipment-status">Important: Temporary shipment delays due to new tariffs. Find out more</a>`;
            shippingMessageTemp.innerHTML = `<a href="https://organicformulastore.com/pages/shipment-status" class="announcement-link-animated" >Important: Temporary shipment delays due to new tariffs. Find out more</a>`;
            if (shippingMessage_pp) {
              shippingMessage_pp.style.display = "block";
              shippingMessage_pp.innerHTML = `<a href="https://organicformulastore.com/pages/shipment-status" class="announcement-link-animated" >Important: Temporary shipment delays due to new tariffs. Find out more</a>`;
            }
          } else if (data.country_name === "Canada" || data.continent_name === "Europe") {
             
            shippingMessage.style.display = "block";
            //shippingMessage.innerHTML = `Free Express Shipping • 2-5 business days to ${userState}`;
            shippingMessage.innerHTML = `Free Express Shipping • 2-5 business days to ${userState}`;
            
            if (shippingMessage_pp) {
              shippingMessage_pp.style.display = "block";
              shippingMessage_pp.innerHTML = `Free Express Shipping • 2-5 business days to ${userState}`;
            }
          } else {
            shippingMessage.style.display = "none";
            if (shippingMessage_pp) {
              shippingMessage_pp.style.display = "none";
            }
          }
        } else {
          console.warn("Shipping message element not found. DOM might not be fully loaded.");
          // Try again after a short delay
          setTimeout(updateShippingMessage, 500);
        }
      } catch (error) {
        console.error("Error fetching location:", error);
        const shippingMessage = document.getElementById("express-shipping-message");
        if (shippingMessage) {
          shippingMessage.style.display = "none";
        }
      }
    }
    
    // Delay the execution slightly to ensure DOM is fully loaded
    setTimeout(updateShippingMessage, 100);
  });
  // ... existing code ...